import { hasActiveFilters, isNameOnlySearch, SearchFilterState } from './searchState';

/**
 * The canonical URL for a /search state (Asana 1219353862024235, Decisions 13
 * and 14, Eric's ruling on `view`).
 *
 *  - unfiltered (bare, or name only): indexable; `?page=N` is self-canonical
 *    for pages past the first, so each page is its own document;
 *  - any other filter: the bare /search (the page is noindex anyway);
 *  - `?view=cards` is never canonical: the Cards view of a search points at the
 *    Printings URL for the same search and page.
 */
export const buildSearchCanonical = (site: string, pathname: string, state: SearchFilterState): string => {
  const path = pathname.toLowerCase().replace(/\/$/, '') || '/search';
  const nameOnly = isNameOnlySearch(state);
  const filtered = hasActiveFilters(state);
  if (filtered && !nameOnly) return `${site}/search`;

  const params = new URLSearchParams();
  if (nameOnly) params.set('name', state.name.trim());
  if (state.page > 1) params.set('page', String(state.page));
  const query = params.toString();
  return `${site}${path}${query ? `?${query}` : ''}`;
};

export default buildSearchCanonical;
